import React from 'react';
import Menuitems from './MenuItems'; // Assuming this is the correct path to your MenuItems file
import { useLocation } from 'react-router';
import { Box, List, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import NavItem from './NavItem';
import NavCollapse from './NavCollapse';
import NavGroup from './NavGroup/NavGroup';
import { GetPermissions, GetUser } from 'src/hooks/useAuthentication';

const SidebarItems = () => {
  const permission = GetPermissions(); // Keep this if you need permission logic
  const user = GetUser(); // Keep this if you need user logic

  const { pathname } = useLocation();
  const pathDirect = pathname;
  const pathWithoutLastPart = pathname.slice(0, pathname.lastIndexOf('/'));
  const customizer = useSelector((state) => state.customizer);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const hideMenu = lgUp ? customizer.isCollapse && !customizer.isSidebarHover : '';

  return (
    <Box sx={{ px: 3 }}>
      <List sx={{ pt: 5 }} className="sidebarNav">
        {Menuitems.map((item) => {
          if (item.subheader) {
            return <NavGroup item={item} hideMenu={hideMenu} key={item.subheader} />;
          }

          if (item.children) {
            return (
              <NavCollapse
                menu={item}
                pathDirect={pathDirect}
                hideMenu={hideMenu}
                pathWithoutLastPart={pathWithoutLastPart}
                level={1}
                key={item.id}
              />
            );
          }

          return <NavItem item={item} key={item.id} pathDirect={pathDirect} hideMenu={hideMenu} />;
        })}
      </List>
    </Box>
  );
};

export default SidebarItems;
